import { StandaloneNoInfinityTeaserBoxTitle } from '@/base/components/element/NoInfinityTeaserBoxTitle';
import { useAppState } from '@/hooks/useAppState';
import { LabradorComponent } from '@/types/component';
import getConfig from 'modules/config';

const LabradorNoInfinityTeaserBoxTitle: LabradorComponent = () => {
  const [{ type }] = useAppState();
  const title = getConfig(`infinityScroll.${type}.title`);

  if (!title) return null;

  return <StandaloneNoInfinityTeaserBoxTitle content={title} />;
};

export default LabradorNoInfinityTeaserBoxTitle;
